export default process.client ? window : {}
